import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

import { StakeCardFrontSide } from "../../../Assets/Images";
import { CircleExclamationOutlined } from "../../../Assets/Icons";

export default function renderStakeCheckingReview(modalContext) {
  const {
    updateModalComponent,
    pushModalStack,
    setModalVariant,
    setModalPromoComponent,
    setModalTitle,
    setModalClassName,
  } = modalContext;

  updateModalComponent(StakeCheckingReview);
  pushModalStack(() => renderStakeCheckingReview(modalContext));
  setModalPromoComponent(null);
  setModalTitle("");
  modalContext.setModalAriaLabel?.("Stake Checking application under review");
  setModalClassName("hide-header no-full-screen");
  setModalVariant(modalVariants.flexDialog);
}

const StakeCheckingReview = () => {
  const { popModalStack } = useModalContext();

  return (
    <>
      <div className="modal-dialog-content mt-6">
        <img className="stake-card-front-side" src={StakeCardFrontSide} alt="" />
        <h3 className="modal-status-title mt-6 mb-5">Your Stake Checking application is under review.</h3>
        <div className="info-alert positive">
          <CircleExclamationOutlined />
          <div>
            Verification submitted
            <div className="text-xs-regular mt-1">
              We’re reviewing your application now. This usually takes a short time. We’ll email and text you as soon as
              there’s an update.
            </div>
          </div>
        </div>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={() => popModalStack(1)}>Got It</PrimaryButton>
      </div>
    </>
  );
};
